import createLogger from "./logger";

export default createLogger("debug");
